import React from "react";
import { Route, Routes } from "react-router-dom";

import { LibraryPage } from "./LibraryPage";
import { McpFormPage } from "./McpFormPage";

export const McpLibraryPage: React.FC = () => {
	return (
		<Routes>
			<Route
				path="/"
				element={<LibraryPage />}
			/>
			<Route
				path="/new"
				element={<McpFormPage />}
			/>
			<Route
				path="/:mcpId"
				element={<McpFormPage />}
			/>
		</Routes>
	);
};
